import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import Modal from '@components/modal/Modal';
import React, { useEffect } from 'react';
import { User } from 'src/types/shared/User';

import useUpdateUser from './hooks/useUpdateUser';
import usePrevious from 'lib/src/hooks/usePrevious';

const UpdateUserModal: React.FC<UpdateUserProps> = ({ user, closeModal }) => {
    const {
        handleSubmit,
        handleChange,
        isPosting,
        formState: { email, firstName, lastName },
        postSuccess,
    } = useUpdateUser(user);

    const prevPostSuccess = usePrevious(postSuccess);

    useEffect(() => {
        if (postSuccess && !prevPostSuccess) closeModal();
    }, [postSuccess, prevPostSuccess, closeModal]);

    return (
        <Modal title="Update user" size="small" closeModal={closeModal}>
            <Form onCancel={closeModal} onSubmit={handleSubmit} isPosting={isPosting}>
                <FormRow>
                    <TextInput
                        type="email"
                        name="email"
                        value={email}
                        onChange={handleChange}
                        label="Email address"
                        placeholder="Email address"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="firstName"
                        value={firstName}
                        onChange={handleChange}
                        label="First name"
                        placeholder="First name"
                        required
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        name="lastName"
                        value={lastName}
                        onChange={handleChange}
                        label="Last Name"
                        placeholder="Last Name"
                        required
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface UpdateUserProps {
    user: User;
    closeModal: () => void;
}

export default UpdateUserModal;
